import { render, staticRenderFns } from "./TroskoviPutnogNaloga.vue?vue&type=template&id=a1a7760c&scoped=true&"
import script from "./TroskoviPutnogNaloga.vue?vue&type=script&lang=ts&"
export * from "./TroskoviPutnogNaloga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a7760c",
  null
  
)

export default component.exports